import { render, staticRenderFns } from "./MdfeTable.vue?vue&type=template&id=49ab11f2&scoped=true"
import script from "./MdfeTable.vue?vue&type=script&lang=js"
export * from "./MdfeTable.vue?vue&type=script&lang=js"
import style0 from "./MdfeTable.vue?vue&type=style&index=0&id=49ab11f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab11f2",
  null
  
)

export default component.exports